<template>
  <el-dialog class="opus-retrieval-dialog" :visible.sync="data.visible" :title="title"
             width="620px"
             center>
    <div class="pv-content">
      <el-form label-width="220px">
        <el-form-item label="预览">
          <el-image :src="data.row.presrc"></el-image>
        </el-form-item>
        <el-form-item label="标题">
          {{ data.row.title }}
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" :loading="data.loading" @click="handleOK">开始</el-button>
        </el-form-item>
        <el-form-item label="结果">
          {{ data.row.data }}
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: '',
    data: {
      visible: false,
      loading: false,
      row: null
    }
  },
  methods: {
    handleOK (e) {
      let that = this
      that.$emit('start', e)
    }
  }
}
</script>

<style>
.opus-retrieval-dialog .el-dialog {
  background: #e5e9f2;
}

.opus-retrieval-dialog .el-dialog__header {
  padding: 0 20px 0px 20px;
  height: 50px;
  background-color: #fff;
}

.opus-retrieval-dialog .el-dialog__title {
  color: #0C0C0C;
  line-height: 50px;
}

.opus-retrieval-dialog .el-dialog__body {
  padding: 0;
}

.opus-retrieval-dialog .pv-content {
  padding-top: 5px;
  width: 620px;
  min-height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.opus-retrieval-dialog .pv-content .el-form-item {
  margin-bottom: 0px;
}

.opus-retrieval-dialog .pv-content .el-form-item.divider {
  border-bottom: 1px solid #348fe2;
}

.opus-retrieval-dialog .pv-content .el-form-item__label {
  color: #0C0C0C;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/OpusRetrievalDialog.vue